/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  app.Filters.TreeFilter = app.Filters.CheckboxList.extend({
    viewClass: app.Filters.TreeFilterView,
    itemClass: app.Filters.TreeItemFilter,
    all: false,
    /**
     * @inheritDoc
     */
    initialize: function () {
      this.set('mas', []);
      var object = this.get('object');
      this.filtersInOneRow = this.get('filtersInOneRow');
      if (object.raw) {
        this.useSort = false;
      }
      var itemAllGoodsSelected = _.every(object.values, function (value) {
        return !value.selected;
      });
      this.view = new this.viewClass({
        model: this,
        object: object,
        parent: this.get('element'),
        filtersInOneRow: this.filtersInOneRow,
        shouldApplySearchBar: !this.get('shouldCategoryFiltersWrap'),
      });
      object.values = $.map(object.values, function (value) {
        return [value];
      });
      var itemAllGoodsCount = this.get('totalCount');
      var countSum = $.map(object.values, function (value) {
        return [value.count];
      }).reduce(function (a, b) {
        return a + b;
      });
      if (this.filtersInOneRow && object.values.length > 1) {
        object.values.unshift({
          count: countSum,
          id: 'all',
          name: 'Все категории',
          total_count: itemAllGoodsCount,
          selectable: true,
          selected: itemAllGoodsSelected,
        });
      }
      if (this.useSort) {
        object.values.sort(function (a, b) {
          return b.count - a.count;
        });
      }
      for (var i in object.values) {
        if (object.values.hasOwnProperty(i)) {
          object.values[i].title = object.values[i].name;
          object.values[i].name = object.values[i].id === 'all' ? '' : parseInt(object.values[i].id, 10);
          object.values[i].level = object.level;
          this.get('mas').push(
            new this.itemClass({
              element: $('#' + object.name + '-list'),
              object: object.values[i],
              index: parseInt(i, 10),
            })
          );
        }
      }
      if (object.name === 'category'
        && this.view.$('.selected').length
      ) {
        this.listenToOnce(Backbone, 'all-filters-rendered', this.scrollToSelectedFilter);
      }
      if (this.get('shouldCategoryFiltersWrap')) {
        this.view.wrapFilters();
      }
      this.view.trigger('children-rendered');
    },

    /**
     * Скроллит к выбранному значению в фильтре категорий.
     */
    scrollToSelectedFilter: function () {
      var selectedFilter = this.view.$('.selected'),
        position = selectedFilter.position(),
        container = this.view.$('#category-list');
      if (position && container.length) {
        container.scrollTop(position.top - container.innerHeight()/2);
      }
    },

    /**
     * @inheritDoc
     */
    prepareQuery: function (mas) {
      var name = '';
      var allSelected = false;
      if (this.filtersInOneRow) {
        var allCategoryElem = $('#filter-category-item-all a');
        allSelected = allCategoryElem.hasClass('selected');
      }
      if (this.all || allSelected) {
        return false;
      }
      
      if (mas.length > 1) {
        for (var i in mas) {
          if (mas[i].click) {
            name = mas[i].name;
          }
        }
      } else {
        name = mas[0].name;
      }
      
      if (name) {
        mas = [name];
      } else {
        mas = [mas[0].name];
      }

      return {
        level: this.get('object').level,
        values: mas
      };
    },
    /**
     * Ставим в начало списка выбраную категорию
     * и добавляем после нее 'Все товары'
     * @param values
     * @returns {Array|*}
     */
    sortBySelected: function (values) {
      var selectedValue = _.find(values, {selected: true});
      var allGoodsValue = _.find(values, {id: 'all'});
      values.unshift(selectedValue, allGoodsValue);
      values = _.uniqBy(values, 'id');
      return values;
    }
  });

})();

}.call(window));